import { render } from "./OverviewCards.vue?vue&type=template&id=0cbca3d4&scoped=true"
import script from "./OverviewCards.vue?vue&type=script&lang=js"
export * from "./OverviewCards.vue?vue&type=script&lang=js"

import "./OverviewCards.vue?vue&type=style&index=0&id=0cbca3d4&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\New folder\\New folder\\Olt Care\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cbca3d4"]])

export default __exports__